import React from "react";
import { GetAllNetworks, api, buildNetworksNav } from "../../../components/helpers";
import Layout from "../../../components/layouts/DocsLayout";
import Head from "next/head";
import { Flex } from "@radix-ui/themes";
import { BreadCrumb } from "../../../components/BreadCrumb";
import { SupportedNetworksGrid } from "../../../components/grids/SupportedNetworksGrid";

export default function Networks({ networks, integrations, user, mobileMenuIsOpen, setMobileMenu, handleToast }) {
    return <><Head><link
        rel="canonical"
        href={`https://www.covalenthq.com/docs/networks/`}
        key="canonical" /></Head><Layout user={user} mobileMenuIsOpen={mobileMenuIsOpen} setMobileMenu={setMobileMenu} handleToast={handleToast} nav={buildNetworksNav(networks)}>
        <BreadCrumb title="Supported Networks" />
        <Flex direction="column" gap="3">
            <h1>Supported Networks</h1>
            <SupportedNetworksGrid networks={networks} integrations={integrations} />
        </Flex>
    </Layout></>;
}

// const getSupportedFeatures = async () => {
//     const url = "https://api.covalenthq.com/v1/chains/features/?key=" + API_KEY;
//     try {
//         const result = await fetch(url, {
//             headers: {
//                 "X-Requested-With": "com.covalenthq.www.docs.api"
//             }
//         });
//         if (result && result.status === 200) {
//             const { data } = await result.json();
//             if (data && data.items) {
//                 return data.items.map((item) => {
//                     return { chainname: item.name, supportsFeatures: item.supports_features };
//                 });
//             }
//         }
//     } catch(error) {
//         console.error(error);
//         return [];
//     }
// };

// const getChainDetails = async (chains, integrationOutput) => {
//     const supportedFeatures = await getSupportedFeatures();
//     const chainDetails: any[] = [];
//     chains.forEach((chain) => {
//         const notSupported = integrationOutput.filter((res) => {
//             if (res.endpoint !== "/v1/xyk/supported_dexes") {
//                 return res.chain === chain.chainname;
//             }
//         });
//         if (supportedFeatures) {
//             const features = supportedFeatures.filter((feature) => feature.chainname === chain.chainname)[0]?.supportsFeatures;
            
//             chainDetails.push({chainname: chain.chainname, doesNotSupportEndpoint: notSupported.map((sup) => {
//                 return sup.endpoint;
//             }), supportedFeatures: features || []});
//         }
//     });
//     return chainDetails;
// };

// const checkIfSupportsClassA = (chain) => {
//     const classA = chain.doesNotSupportEndpoint.filter((ep) => !ep.includes("xyk"));
//     let ranking = 0;
//     if (classA.length === 0) {
//         ranking = 1;
//     } else if (classA.length <= 3) {
//         ranking = 2;
//     }
//     return ranking;
// };

// const checkIfSupportsClassB = (chain) => {
//     const classB = chain.doesNotSupportEndpoint.filter((ep) => ep.includes("xyk"));
//     return classB.length === 0;
// };

// const checkIfSupportsNFTAssetandMetadataCache = (chain) => {
//     return chain.supportedFeatures.includes("com.covalenthq.scout.NFTAssetPrecaching") && chain.supportedFeatures.includes("com.covalenthq.scout.NFTMetadataPrecaching");
// };

// const checkIfSupportsTokenHolders = (chain) => {
//     return chain.supportedFeatures.includes("com.covalenthq.ingestor.ContractBalancePrecaching") && chain.supportedFeatures.includes("com.covalenthq.ingestor.MultitokenBalancePrecaching") && chain.supportedFeatures.includes("com.covalenthq.ingestor.NFTOwnerPrecaching");
// };

// const checkIfSupportsTracing = (chain) => {
//     return chain.supportedFeatures.includes("com.covalenthq.ingestor.Tracing");
// };

// const checkIfSupportsHumanDecodedTransactions = (chain) => {
//     return chain.supportedFeatures.includes("com.covalenthq.api.TransactionDetails");
// };

// export const evaluateChains = async (chains, integrationOutput) => {
//     const chainDetails = await getChainDetails(chains, integrationOutput);
//     const evaluation = chainDetails.map((chain, index) => {
//         const classA = checkIfSupportsClassA(chain);
//         const classB = checkIfSupportsClassB(chain);
//         const classC = chains[index]?.increment ? true : false;
//         const humanDecodedTransactions = checkIfSupportsHumanDecodedTransactions(chain);
//         const nftAssetAndMetadataCache = checkIfSupportsNFTAssetandMetadataCache(chain);
//         const tokenHolders = checkIfSupportsTokenHolders(chain);
//         const traces = checkIfSupportsTracing(chain);

//         let stage = 1;
//         if (classA && classB) {
//             stage += 1;

//             if (nftAssetAndMetadataCache) {
//                 stage += 1;

//                 if (humanDecodedTransactions) {
//                     stage += 1;

//                     if (tokenHolders) {
//                         stage += 1;

//                         if (traces) {
//                             stage += 1;

//                         }
//                     }
//                 }
//             }
//         }

//         return {
//             chainname: chain.chainname,
//             stagesupport: [
//                 {
//                     classA,
//                     classB,
//                     classC,
//                     humanDecodedTransactions,
//                     nftAssetAndMetadataCache,
//                     tokenHolders,
//                     traces
//                 }
//             ],
//             stage: stage
//         };
//     });
//     return evaluation;
// };

export async function getStaticProps() {
    const networks = await GetAllNetworks();
    const integrations = await api.get_all_integrations();
    // const evaluations = await evaluateChains(networks, integrationOutput);
    // const networksWithEvaluations = networks.map((network) => {
    //     const matchingEvaluation = evaluations.find(evaluation => evaluation.chainname === network.chainname);
    //     if (matchingEvaluation) {
    //         network.integrationstage = {};
    //         network.integrationstage.stagesupport = matchingEvaluation.stagesupport;
    //         network.integrationstage.stage = matchingEvaluation.stage;
    //     }
        
    //     return network;
    // });
    return {
        props: {
            networks: networks,
            integrations: integrations.data.allIntegrationstages,
            component: "Networks",
            revalidate: 60
        },
    };
}
